import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminWakeUp(props) {
    const formsiteRef = useRef(null)

    const [sitelist, setSiteList] = useState([]);
    const [siteitem, setSiteitem] = useState({
        sitename_th: '',
        siteaddress: '',
        sitecode_txt: '',
        mac_address: ''
    });

    const [modal_sites, setModal_sites] = useState(false)
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {

    }

    function init_item() {
        setSiteitem({
            sitename_th: '',
            siteaddress: '',
            sitecode_txt: '',
            mac_address: ''
        })
    }

    useEffect(() => {
        api_load()
        return () => {
            setSiteList([])
        };
    }, []);

    async function api_load() {
        setmodal_load({ enable: true, message: "Loading sites info." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/wakeup/getdata", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setSiteList(response.data.mac)
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_edit() {
        var formelement = formsiteRef.current
        formelement.classList.remove("was-validated");
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");

            setmodal_load({ enable: true, message: "Editing MAC address in a database." })
            await sleep(500)

            const formData = new FormData();
            formData.append('mac_address', siteitem.mac_address)
            formData.append('sitecode', siteitem.sitecode_txt)
            axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/wakeup/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_sites(false)
                    init_item()
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your MAC address has been edited in a database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        })
                    }
                    if (response.data.mac !== null && response.data.mac !== undefined) {
                        setSiteList(response.data.mac)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    })
                });
        }
    }

    async function api_send_wakeup(sitecode, mac) {
        setmodal_load({ enable: true, message: "Sending wake up request to local IOT module." })
        await sleep(500)

        const formData = new FormData();
        formData.append('mac_address', mac)
        formData.append('sitecode', sitecode)
        axios.post(process.env.REACT_APP_API_URL + "/proxy/iot/" + sitecode + "/api/pc/wakeup/activate", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer GrU5w8y8CKjQPoBCfkjI8fAaoFUP6KLg5xG6h0pfJ2pbfgkPKCc8k522Z7wxy6xb"
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your has been sent to IOT module.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }


    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <h4 className="mb-1"><i className="fas fa-power-off"></i> PC Wake On LAN</h4>
                            <p className="mb-3">Manage all sites PC mac address and waku up the PC</p>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" type="button" onClick={() => { api_load() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>Sites Table (Found {sitelist.length} Sites)</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered  text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>Site Code.</th>
                                        <th>Site Name.</th>
                                        <th>MAC Address</th>
                                        <th className="text-center " style={{ width: "100px" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        sitelist?.map((site, index) => (
                                            <tr key={site.sitecode_txt} >
                                                <td className='font-sarabun'>{site.sitecode_txt}</td>
                                                <td className='font-sarabun' ><div style={{ fontWeight: "600" }}>{site.sitename_th}</div> <p className='mt-1 mb-0 font-sarabun'>{site.siteaddress}</p></td>
                                                <td className='font-sarabun'>{site.mac_address}</td>
                                                <td>
                                                    <Link className="btn btn-icon btn-sm btn-warning btn-hover btn-bordered" title="Edit" onClick={() => {
                                                        setSiteitem(site);
                                                        setModal_sites(true);
                                                    }}><i className="fas fa-pen"></i></Link>
                                                    <Link className="btn btn-icon btn-sm btn-danger btn-hover btn-bordered mx-2" title="Send Wake On Lan Command" onClick={() => {
                                                        api_send_wakeup(site.sitecode_txt, site.mac_address)
                                                    }}><i className="fas fa-power-off"></i></Link>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>

                    {
                        modal_sites ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-power-off"></i> Edit MAC Address {siteitem.sitecode_txt}</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_sites(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formsiteRef} className='mt-3 mb-1 mb-md-4' action="" method="POST" encType="multipart/form-data" >
                                                    <div className="row mb-3">
                                                        <div className="col-md-12 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="sitename_en">Local PC MAC Address</label>
                                                                <input type="text" className="form-control" name="sitename_en" value={siteitem.mac_address} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        mac_address: e.target.value
                                                                    })
                                                                }}
                                                                    placeholder="eg. 00:1A:2B:3C:4D:5E"
                                                                    pattern="^([0-9A-Fa-f]{2}:){5}([0-9A-Fa-f]{2})$"
                                                                    required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_sites(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_edit() }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminWakeUp